import { createContext, useContext } from "react"
import { ICompany } from "platform-client/types"

export interface ICompaniesContext {
  companies: ICompany[]
  companiesMap: Map<string, string>
  isLoading: boolean
}

const initialCompaniesState: ICompaniesContext = {
  companies: [],
  companiesMap: new Map(),
  isLoading: true
}

const CompaniesContext = createContext<ICompaniesContext>(initialCompaniesState)

export const useCompaniesContext = (): ICompaniesContext =>
  useContext(CompaniesContext)

export default CompaniesContext
